import { render, staticRenderFns } from "./ShotValResult.vue?vue&type=template&id=144f82c7&"
import script from "./ShotValResult.vue?vue&type=script&lang=js&"
export * from "./ShotValResult.vue?vue&type=script&lang=js&"
import style0 from "./ShotValResult.vue?vue&type=style&index=0&id=144f82c7&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports